export function updateCompanyRun($auth, $companies) {
	"ngInject";
	if ($auth.isAuthenticated()) {
		$companies.fetch();
	}
}


// WEBPACK FOOTER //
// ./sources/bootstrap/updateCompany.run.js